// src/app/core/services/logrocket.service.ts
import { Injectable, OnDestroy } from '@angular/core';
import { AuthenticationService } from '../Auth/authservice';
import { takeUntil, Subject } from 'rxjs';

declare let LogRocket: any;
@Injectable({
  providedIn: 'root',
})
export class LogRocketService implements OnDestroy {
  private os = 'Unknown OS';
  private browser = 'Unknown Browser';
  private browserVersion = 'Unknown';
  private destroy$ = new Subject<void>();

  private isInitialized = false;
  private isIdentified = false;

  constructor(private authService: AuthenticationService) {
    if (typeof window !== 'undefined') {
      this.detectEnvironment();
    }
  }

  /**
   * Detect OS and Browser details
   */
  private detectEnvironment(): void {
    const ua = navigator.userAgent;

    // OS detection
    if (ua.includes('Win')) this.os = 'Windows';
    else if (ua.includes('Mac')) this.os = 'MacOS';
    else if (ua.includes('Linux')) this.os = 'Linux';
    else if (/Android/i.test(ua)) this.os = 'Android';
    else if (/iPhone|iPad|iPod/i.test(ua)) this.os = 'iOS';

    // Browser detection
    const match =
      ua.match(/(firefox|msie|chrome|safari|trident(?=\/))\/?\s*(\d+)/i) || [];

    if (/trident/i.test(match[1])) {
      this.browser = 'Internet Explorer';
      const ieVersion = /\brv[ :]+(\d+)/g.exec(ua);
      this.browserVersion = ieVersion ? ieVersion[1] : '';
    } else if (match[1]) {
      this.browser = match[1];
      this.browserVersion = match[2] || '';
    }
  }

  init(): void {
    if (typeof window === 'undefined' || !LogRocket || this.isInitialized) {
      return;
    }
    LogRocket.init('uztwlg/nada');
    this.isInitialized = true;

    // ✅ Identify user when auth data arrives
    this.authService.fincomData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && !this.isIdentified) {
          this.identifyUser(user);
        }
      });
  }

  private identifyUser(user: any): void {
    LogRocket.identify(user.recordNumber, {
      name: user.name,
      email: user.email,
      subscriptionType: 'pro',
      os: this.os,
      browser: this.browser,
      browserVersion: this.browserVersion,
    });

    this.isIdentified = true;
  }

  logEvent(eventName: string, params?: Record<string, any>): void {
    if (!this.isInitialized || typeof window === 'undefined') return;

    LogRocket.track(eventName, {
      ...params,
      os: this.os,
      browser: this.browser,
      browserVersion: this.browserVersion,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
